import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import './../MoneyTransferComponent/Subtransaction.css';
import './../MoneyTransferComponent/MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { Link } from "react-router-dom";
import { setMoneyTransferProgress, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setStatusEnqResponse, setMoneyTransferTotalAmount, setTxnAmount1, setTxnsurcharge1, setTxntotalAmount1, setMoneyTransferProgress1, setStatusEnqResponse1 } from '../../redux/misc-data/misc-data.action';
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { setCreateOrderRes2, setMoneyTransferProgress2, setStatusEnqResponse12, setStatusEnqResponse2, setTxnAmount2, setTxnsurcharge2, setTxntotalAmount2 } from "../../redux/billpayDetails/billpay.action";
import miscReducer from "../../redux/misc-data/misc-data.reducer";
import FinxPayLogo1 from "../../assests/images/finxpay.png";
import FinxPayLogo from "../../assests/images/emitra-logo8.png";
import FinxPayLogo2 from "../../assests/images/emitra-logo2.png";

const httpClient = axios.create();

class BillPayTransferDetails2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            moneyTransferFinalStatusCompleted: false,
            finalTransferMessage: '',
            counter: 0,
            exceptionCounter: 0,
            moneyTransferProgress1: '',
            debitedFrom: '',
            payRef: '',
            payTxnId: '',
            billerId: '',
            consumerNo: '',
            kNo: '',
            consumerName: '',
            billDate: '',
            dueDate: '',
            billNumber: '',
            txnSubOrder: '',
            printErr: '',
            paymentStat: '',
            printLoading: false,
            showEmitraOriginalLogo: true,
            orderStatus: '',
            billpaymentStuas: ''
        }
    }


    componentDidMount() {
        store.dispatch(setTxnAmount2(''));
        store.dispatch(setTxnsurcharge2(''));
        store.dispatch(setTxntotalAmount2(''));
        // store.dispatch(setMoneyTransferTotalAmount(''));
        store.dispatch(setMoneyTransferProgress2(''));
        store.dispatch(setStatusEnqResponse2(''));

        var interVal = setInterval(() => {
            this.loadCurTxnStatus(interVal);
        }, 30000);


    }

    loadCurTxnStatus(interVal) {

        if (this.state.counter <= 3) {
            var txnSearchurl = '/api/v1/billpay/order/search/' + this.props.createOrderRes2.orderId + '/' + this.props.agentInfo.id;

            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            httpClient.get(txnSearchurl, { headers }
            ).then((response) => {
                // alert('txn search response' + JSON.stringify(response.data));

                var counter = this.state.counter;
                counter++;

                this.setState({
                    counter: counter
                })

                if (response.data.response.msg == 'SUCCESS') {
                    console.log('txn search success response....' + response.data);
                    if (response.data != null &&
                        response.data != undefined &&
                        response.data != "" &&
                        response.data.orders != null &&
                        response.data.orders != undefined &&
                        response.data.orders != "" &&
                        response.data.orders.length > 0) {
                        var txn = response.data.orders[0];
                        //alert(JSON.stringify(billpayTxn));

                        var orderStatus = '';
                        if (txn.status == '' || txn.status == undefined || txn.status == null) {
                            orderStatus = 'Order Failed';
                            clearInterval(interVal);
                            this.setState({
                                counter: 4,
                                orderStatus: orderStatus
                            })


                        }

                        if (txn.status == 'SUCCESS') {
                            orderStatus = 'Order Successful';
                            clearInterval(interVal);
                            this.setState({
                                counter: 4,
                                orderStatus: orderStatus
                            })

                        }

                        if (txn.status == 'PROCESSING') {
                            if (txn.paymentStatus == 'SECURED') {
                                orderStatus = 'Payment deducted, Order Pending';
                            } else {
                                orderStatus = 'Order Pending';
                            }
                            this.setState({
                                orderStatus: orderStatus
                            })

                        }

                        if (txn.status == 'PENDING') {
                            if (txn.paymentStatus == 'SECURED') {
                                orderStatus = 'Order Successfully Submitted';
                                clearInterval(interVal)
                                this.setState({
                                    counter: 4
                                })
                                
                            } else {
                                orderStatus = 'Order Pending';
                            }
                            
                            this.setState({
                                orderStatus: orderStatus
                            })
                        }


                        if (txn.status == 'ACCEPTED'
                            || txn.status == 'HUNG') {
                            //paymentStatus = 'Successfully Submitted';
                            orderStatus = 'Order Pending';
                            this.setState({
                                orderStatus: orderStatus
                            })
                        }
                        if (txn.status == 'FAILED'
                            || txn.status == 'FAIL'
                            || txn.status == 'INTERNAL_FAILURE'
                            || txn.status == 'SUCCESS_TO_FAILED'
                            || txn.status == 'NOT_FOUND') {
                            orderStatus = 'Order Failed';
                            clearInterval(interVal);
                            this.setState({
                                counter: 4,
                                orderStatus: orderStatus
                            })
                        }
                        if (txn.status == 'AUTO_REVERSED'
                            || txn.status == 'MANUALLY_REVERSED') {
                            orderStatus = 'Order Reversed';
                            clearInterval(interVal);
                            this.setState({
                                counter: 4,
                                orderStatus: orderStatus
                            })
                        }


                    } else {
             
                        orderStatus = 'Order Pending';

                        this.setState({
                            orderStatus: orderStatus
                        })
                    }
                } else {
    
                    var orderStatus = 'Order Pending';
                    this.setState({
                        orderStatus: orderStatus
                    })
                }
            }).catch(err => {

                var orderStatus = 'Order Pending';
                var counter = this.state.counter;
                counter++;
                this.setState({
                    counter: counter,
                    orderStatus: orderStatus
                })
            });
        } else {
            console.log('interVal Exceed');
            clearInterval(interVal);
            this.setState({
                orderStatus: 'Order pending,Please check transaction history later'
            })

        }

    }
    componentWillUnmount() {
    }
    printdiv = (event) => {
        event.preventDefault();

        var showModalDiv = document.getElementById('#print-modal');
        showModalDiv.style.display = 'none';
        this.setState({
            showEmitraOriginalLogo: false
        })
        setTimeout(() => {
            var divContents = document.getElementById("#print-modal").innerHTML;
            var a = window.open('', '', 'height=500, width=500');
            a.document.write('<html>');
            a.document.write('<body>');
            a.document.write(divContents);
            a.document.write('</body></html>');
            a.document.close();
            a.print();
        }, 100);

    }



    print = (event) => {
        event.preventDefault();
        window.print();
    }

    closeModal = (e) => {
        e.preventDefault();
        var showModalDiv = document.getElementById('#print-modal');
        showModalDiv.style.display = 'none';
    }

    moDalPrint = (event) => {


        event.preventDefault();
        this.setState({
            printErr: '',
            printLoading: true
        })
        this.setState({
            showEmitraOriginalLogo: true
        })

        var txnSearchurl = '/api/v1/billpay/order/search/' + this.props.createOrderRes2.orderId + '/' + this.props.agentInfo.id;

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': this.props.clientRole
        }

        setTimeout(() => {
            // alert('called....');
            httpClient.get(txnSearchurl, { headers }
            ).then((response) => {
                // alert(response.data.response.displayMsg)

                this.setState({
                    printLoading: false
                })

                console.log('txn search response' + JSON.stringify(response.data));
                if (response.data.response.msg == 'SUCCESS') {
                    console.log('txn search success response....' + response.data);
                    if (response.data != null &&
                        response.data != undefined &&
                        response.data != "" &&
                        response.data.orders != null &&
                        response.data.orders != undefined &&
                        response.data.orders != "" &&
                        response.data.orders.length > 0) {
                        var txn = response.data.orders[0];
                        //alert(JSON.stringify(billpayTxn));

                        var orderStatus = '';
                        if (txn.status == '' || txn.status == undefined || txn.status == null) {
                            orderStatus = 'BillPay Order Failed';

                            this.setState({
                                billpaymentStuas: orderStatus
                            })
                        }

                        if (txn.status == 'SUCCESS') {
                            orderStatus = 'BillPay Order Successful';

                            this.setState({
                                billpaymentStuas: orderStatus
                            })

                        }

                        if (txn.status == 'PROCESSING') {
                            if (txn.paymentStatus == 'SECURED') {
                                orderStatus = 'BillPay Payment deducted, Order Pending';
                            } else {
                                orderStatus = 'BillPay Order Pending';
                            }
                            this.setState({
                                billpaymentStuas: orderStatus
                            })

                        }

                        if (txn.status == 'PENDING') {
                            if (txn.paymentStatus == 'SECURED') {
                                orderStatus = 'BillPay Order Successfully Submitted';
                            } else {
                                orderStatus = 'BillPay Order Pending';
                            }
                            this.setState({
                                billpaymentStuas: orderStatus
                            })
                        }


                        if (txn.status == 'ACCEPTED'
                            || txn.status == 'HUNG') {
                            //paymentStatus = 'Successfully Submitted';
                            orderStatus = 'BillPay Order Pending';
                            this.setState({
                                billpaymentStuas: orderStatus
                            })
                        }
                        if (txn.status == 'FAILED'
                            || txn.status == 'FAIL'
                            || txn.status == 'INTERNAL_FAILURE'
                            || txn.status == 'SUCCESS_TO_FAILED'
                            || txn.status == 'NOT_FOUND') {
                            orderStatus = 'BillPay Order Failed';
                            this.setState({
                                billpaymentStuas: orderStatus
                            })
                        }
                        if (txn.status == 'AUTO_REVERSED'
                            || txn.status == 'MANUALLY_REVERSED') {
                            orderStatus = 'BillPay Order Reversed';
                            this.setState({

                                billpaymentStuas: orderStatus
                            })
                        }

                        var payRefId = '';
                        var payTxnId = '';
                        if (txn.optional != null &&
                            txn.optional != undefined &&
                            txn.optional != '' &&
                            txn.optional.PAYMENT_REF_ID != '' &&
                            txn.optional.PAYMENT_REF_ID != undefined &&
                            txn.optional.PAYMENT_REF_ID != null) {
                            //alert(1);
                            payRefId = txn.optional.PAYMENT_REF_ID;
                        } else {
                            if (txn.paymentRefId != ''
                                && txn.paymentRefId != undefined
                                && txn.paymentRefId != null) {
                                payRefId = txn.paymentRefId;
                            }
                            // payRefId = txn.paymentRefId != ''
                            //     && txn.paymentRefId != undefined
                            //     && txn.paymentRefId != null
                            //     && txn.paymentRefId;
                        }
                        if (txn.optional != null &&
                            txn.optional != undefined &&
                            txn.optional != '' &&
                            txn.optional.PAYMENT_TXN_ID != '' &&
                            txn.optional.PAYMENT_TXN_ID != undefined &&
                            txn.optional.PAYMENT_TXN_ID != null) {
                            //alert(2);
                            payTxnId = txn.optional.PAYMENT_TXN_ID;
                        } else {
                            if (txn.paymentTxnId != ''
                                && txn.paymentTxnId != undefined
                                && txn.paymentTxnId != null) {
                                payTxnId = txn.paymentTxnId;
                            }
                            // payTxnId = txn.paymentTxnId != ''
                            //     && txn.paymentTxnId != undefined
                            //     && txn.paymentTxnId != null
                            //     && txn.paymentTxnId;
                        }


                        this.setState({
                            showModal: true,
                            // paymentStatus: orderStatus,
                            // paymentStat: paymentStatus,
                            transferredAmount: (txn.transaction != null && txn.transaction != undefined &&
                                txn.transaction != '')
                                ? parseFloat(txn.transaction.amount).toFixed(2) :
                                '0.00',
                            orderId: txn.id != null ? txn.id : 'Unlnown Id',
                            createdOn: moment(txn.createdOn).format('DD-MM-YYYY hh:mm:ss'),
                            surcharge: (txn.status.toLowerCase() != 'failed' && txn.txnDetails != null) ?
                                txn.txnDetails.surcharge != null ?
                                    parseFloat(txn.txnDetails.surcharge).toFixed(2) : '0.00' : '0.00',
                            totalAmount: parseFloat((txn.transaction.amount) -
                                (txn.txnDetails != null ? txn.txnDetails.surcharge : 0)).toFixed(2),
                            debitedFrom: this.props.agentInfo.mobile,
                            payRef: (payRefId != '' && payRefId != undefined && payRefId != null) ?
                                payRefId : 'NA',
                            payTxnId: (payTxnId != '' && payTxnId != undefined && payTxnId != null) ?
                                payTxnId : 'NA',
                            billerId: txn.billerTxnId,
                            consumerNo: txn.optional != null && txn.optional.customer_number != null &&
                                txn.optional.customer_number != '' && txn.optional.customer_number,
                            kNo: txn.optional != null && txn.optional.K_NUMBER != null &&
                                txn.optional.K_NUMBER != '' && txn.optional.K_NUMBER,
                            consumerName: (txn.optional != null && txn.optional.name != null &&
                                txn.optional.name != '' && txn.optional.name != undefined) ?
                                txn.optional.name : 'NA',
                            billDate: (txn.optional != null && txn.optional.billDate != null &&
                                txn.optional.billDate != '' && txn.optional.billDate != undefined) ?
                                txn.optional.billDate : 'NA',
                            dueDate: (txn.optional != null && txn.optional.dueDate != null &&
                                txn.optional.dueDate != '' && txn.optional.dueDate != undefined) ?
                                txn.optional.dueDate : 'NA',
                            billNumber: (txn.optional != null && txn.optional.billNumber != null &&
                                txn.optional.billNumber != '' && txn.optional.billNumber != undefined) ?
                                txn.optional.billNumber : 'NA',

                        })

                        var showModalDiv = document.getElementById('#print-modal');
                        showModalDiv.style.display = 'block';

                    }

                } else {
                    var showModalDiv = document.getElementById('#print-modal');
                    showModalDiv.style.display = 'none';
                    this.setState({
                        printErr: response.data.response.displayMsg
                    })

                }
            }).catch(error => {
                var showModalDiv = document.getElementById('#print-modal');
                showModalDiv.style.display = 'none';
                this.setState({
                    printErr: error.message,
                    printLoading: false
                })

            });
        }, 2000);


    }


    render() {
        return (
            <div>
                <HeaderCommon />
                <Menu />
                <div class="main">
                    <div class="right-side">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-12">
                                    <div class="card-b" id="rightdiv">
                                        <div id="recenttxn">
                                            <div class="head">
                                                <h3>Billpay Details</h3>
                                                <Link to='/billpay'>
                                                    <button class="dbbtn" type="button">Back</button>
                                                </Link>
                                            </div>
                                            <div class="benedtls">
                                                <div class="row">
                                                    <div class="col-12 col-lg-4 order-lg-2">
                                                        {/* {'orderStatus:' + this.state.orderStatus} */}

                                                        {/* {'this.state.paymentStat'+this.state.paymentStat} */}
                                                        {this.state.orderStatus == '' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={ProgressGif} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Pending,Please wait for final status...</h3>
                                                            </div>
                                                        }
                                                        {this.state.orderStatus == 'Order Failed' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={MtFailed} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Failed</h3>
                                                            </div>
                                                        }
                                                        {this.state.orderStatus == 'Order Successful' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={MtSuccess} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Sucessfully Submitted</h3>
                                                            </div>
                                                        }
                                                        {this.state.orderStatus == 'Payment deducted, Order Pending' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={ProgressGif} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Payment deducted, Order Pending,Please Wait..</h3>
                                                            </div>
                                                        }
                                                        {this.state.orderStatus == 'Order Successfully Submitted' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={MtSuccess} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Successfully Submitted</h3>
                                                            </div>
                                                        }
                                                        {this.state.orderStatus == 'Order Pending' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={ProgressGif} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Pending,Please wait...</h3>
                                                            </div>
                                                        }

                                                        {this.state.orderStatus == 'Order pending,Please check transaction history later' &&
                                                            <div class="mtprogess" id="mtrun">
                                                                <img src={MtSuccess} alt="process" class="img-fluid" />
                                                                <h3 class="pending">Order Pending,Please check transaction history later</h3>
                                                            </div>
                                                        }
                                                        {/* <div class="mtprogess" id="mtrun">
                                                            <img src={MtSuccess} alt="process" class="img-fluid" />
                                                            <h3 class="pending">Sucessfully Submitted</h3>
                                                        </div> */}


                                                    </div>
                                                    <div class="col-12 col-md-6 col-lg-4 order-lg-1">
                                                        <div class="graycard">
                                                            <div class="bankdtl">
                                                                {/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
                                                                <h5>Operator Name</h5>
                                                                <p>{this.props.biillpayOperator}</p>
                                                            </div>
                                                            <hr />
                                                            <div class="bankdtl">
                                                                <h5>Mobile Number</h5>
                                                                <p>{this.props.billPayMobile}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-6 col-lg-4 order-lg-3">
                                                        <div class="graycard">
                                                            <div class="bankdtl">
                                                                <h5>Retailer Id</h5>
                                                                <p>{this.props.agentInfo.id}</p>
                                                            </div>
                                                            <hr />
                                                            <div class="acntifsc">
                                                                <h5>Retailer Name</h5>
                                                                <p>{this.props.agentInfo.kioskName}</p>
                                                            </div>

                                                            <div class="acntifsc rtxt">
                                                                <h5>Kiosk Code</h5>
                                                                <p>{this.props.agentInfo.kioskCode}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="subtxn">
                                                <h4>Sub Transactions</h4>


                                                {/* <div class={this.state.paymentStat == 'Failed' ? 'subtxn-failed' :
                                                    this.state.paymentStat == 'Successfully Submitted' ? 'subtxn-pending' :
                                                        this.state.paymentStat == 'Success' ? 'subtxn-pending' :
                                                            this.state.paymentStat == 'Reversed' ? 'subtxn-pending' :
                                                                'subtxn-pending'
                                                }> */}
                                                <div class='subtxn-pending'>
                                                    <div class="col-6 col-md-3 col-lg-3 order-md-1">
                                                        <div class="subtxt txnsts">
                                                            {this.state.orderStatus == '' ? 'Order Pending' :
                                                                this.state.orderStatus}
                                                        </div>
                                                    </div>

                                                    {/* <div class="col-12">
                                                        <div class="subtxt txnsts">

                                                            {this.props.createOrderRes2.response.displayMsg != null &&
                                                                this.props.createOrderRes2.response.displayMsg != '' &&
                                                                this.props.createOrderRes2.response.displayMsg != undefined &&
                                                                <b> Message:  {this.props.createOrderRes2.response.displayMsg}
                                                                </b>
                                                            }
                                                            <br />

                                                            {this.props.createOrderRes2.response.tpsRspMsg != null &&
                                                                this.props.createOrderRes2.response.tpsRspMsg != '' &&
                                                                this.props.createOrderRes2.response.tpsRspMsg != undefined &&
                                                                <b> Third Party message:  {this.state.thirdPartyMsg}
                                                                </b>
                                                            }

                                                        </div>
                                                    </div> */}
                                                    <div class="row">
                                                        <div class="col-6 col-md-2 col-lg-4 order-md-4">
                                                            <div class="subtxt subamunt rtxt">₹ {parseFloat(this.props.transferTotalAmount2)}</div>
                                                        </div>

                                                        <div class="col-12 col-md-4 col-lg-6 order-md-2">
                                                            <div class="subtxt subid">Transaction ID: {this.props.createOrderRes2.orderId}</div>
                                                        </div>

                                                        <div class="col-12 col-md-3 col-lg-4 order-md-3">
                                                            <div class="subtxt">{moment(this.props.createOrderStatusResponse2.time).format('DD-MM-YYYY HH:mm:ss')}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>



                                            {this.props.createOrderRes2 != '' &&
                                                <div class="paydtl">
                                                    <div class="row">
                                                        <div class="col-12 col-sm-6">
                                                            <div class="orderdetail1">
                                                                <div class="txnhead">Order Details</div>
                                                                <div class="odramt">
                                                                    <p>Order Amount <span>₹ {parseFloat(this.props.transferTotalAmount2).toFixed(2)}</span></p>
                                                                    <p>Commission <span>₹ {parseFloat(this.props.surcharge2).toFixed(2)}</span></p>
                                                                </div>
                                                                <div class="ttlamt">
                                                                    <p>Total Amount <span>₹ {parseFloat(this.props.transferTotalAmount2).toFixed(2) - parseFloat(this.props.surcharge2).toFixed(2)}</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-12 col-sm-6">
                                                            <div class="tnsfrdetail1">
                                                                <div class="txnhead">Transaction Details</div>
                                                                <div class="odramt">
                                                                    <p>Transfer Amount <span>₹ {
                                                                        // this.state.paymentStat != 'Failed' &&
                                                                        this.props.transferTotalAmount2 != '' &&
                                                                            this.props.surcharge2 != ''

                                                                            ? (parseFloat(this.props.transferTotalAmount2).toFixed(2))
                                                                            : 0.00}</span></p>
                                                                    <p>Commission <span>₹ {
                                                                        // this.state.paymentStat != 'Failed' &&
                                                                        this.props.surcharge1 != ''

                                                                            ? parseFloat(this.props.surcharge2).toFixed(2) : 0.00}</span></p>
                                                                </div>
                                                                <div class="ttlamt">
                                                                    <p>Total Amount <span>₹ {
                                                                        // this.state.paymentStat != 'Failed' &&
                                                                        this.props.transferTotalAmount2 != '' && this.props.surcharge2 != ''
                                                                            ?
                                                                            parseFloat(this.props.transferTotalAmount2).toFixed(2) - parseFloat(this.props.surcharge2).toFixed(2) : 0.00}</span></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {this.state.counter >= 4 &&
                                                <div class="txn-btn">
                                                    {
                                                        <button type="button" class="print"
                                                            // data-bs-toggle="modal"
                                                            // data-bs-target="#print"
                                                            onClick={this.moDalPrint}
                                                            disabled={this.state.printLoading == true && true}>Print</button>
                                                    }
                                                    {this.state.printLoading == true &&
                                                        <div class='valid-success'>
                                                            Please wait...
                                                        </div>}
                                                    {this.state.printErr != '' &&
                                                        this.state.printErr != null &&
                                                        this.state.printErr != undefined &&
                                                        <div class='valid-error'>
                                                            {this.state.printErr}
                                                        </div>}
                                                    {/* <button type="button" class="help"></button> */}
                                                </div>
                                            }


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div

                    id="#print-modal"
                    class="modal" role="dialog"
                    // class="modal fade"
                    // data-bs-backdrop="static"
                    // data-bs-keyboard="false" 
                    tabindex="-1">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            {/* <div class="modal-header modhead">
								<h5 class="modal-title">Billpay Receipt</h5>
								{this.state.showEmitraOriginalLogo == true &&
									<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
								}
							</div> */}
                            <div class="modal-body">

                                <div class="printtable">
                                    {this.state.showEmitraOriginalLogo == true &&
                                        <div class="printlogo">

                                            <img src={FinxPayLogo1} alt="logo" />
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;

                                            <img src={FinxPayLogo2} alt="logo" />
                                        </div>
                                    }
                                    {this.state.showEmitraOriginalLogo == false &&
                                        <div class="printlogo">
                                            <img src={FinxPayLogo1} alt="logo" />
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;
                                            &emsp;


                                            <img src={FinxPayLogo} alt="logo"
                                            // height={180}  width={50}
                                            ></img>
                                            {/* <img src={FinxPayLogo} alt="logo" /> */}
                                        </div>
                                    }

                                    <table class="table table-striped table-bordered" border="1" border-collapse>
                                        <tbody>
                                            <tr>
                                                <td>Payment Status:</td>
                                                <td><strong> {this.state.billpaymentStuas}</strong></td>
                                            </tr>

                                            <tr>
                                                <td>Billpay Amount:</td>
                                                <td>₹ {this.state.transferredAmount}</td>
                                            </tr>
                                            {/* <tr>
												<td>Comission:</td>
												<td>₹ {this.state.surcharge}</td>
											</tr> */}



                                            {/* <tr>
												<td>Total Amount:</td>
												<td>₹ {parseFloat(this.state.totalAmount).toFixed(2)}</td>
											</tr> */}

                                            {/* <tr>
												<td>Order Id:</td>
												<td>{this.state.orderId}</td>
											</tr> */}

                                            <tr>
                                                <td>Date:</td>
                                                <td>{this.state.createdOn}</td>
                                            </tr>
                                            <tr>
                                                <td>Debited From:</td>
                                                <td>{this.props.agentInfo.id}</td>
                                            </tr>

                                            {(this.state.payRef != '' &&
                                                this.state.payRef != undefined &&
                                                this.state.payRef != null &&
                                                this.state.payRef != null) &&
                                                <tr>
                                                    <td>eMitra Reference No:</td>
                                                    <td>{this.state.payRef}</td>
                                                </tr>
                                            }
                                            {(this.state.payTxnId != '' &&
                                                this.state.payTxnId != undefined &&
                                                this.state.payTxnId != null) &&
                                                <tr>
                                                    <td>eMitra Transaction Id:</td>
                                                    <td>{this.state.payTxnId}</td>
                                                </tr>
                                            }
                                            {(this.state.billerId != '' &&
                                                this.state.billerId != undefined &&
                                                this.state.billerId != null) &&
                                                <tr>
                                                    <td>Biller Txn Id:</td>
                                                    <td>{this.state.billerId}</td>
                                                </tr>
                                            }
                                            <tr>
                                                <td>Consumer_No/K_NUMBER/Consumer_Name/BILL_NUMBER:</td>
                                                <td>{this.state.consumerNo}/{this.state.kNo}/{this.state.consumerName}/{this.state.billNumber}</td>
                                            </tr>
                                            {/* {(this.state.consumerNo != '' &&
												this.state.consumerNo != undefined &&
												this.state.consumerNo != null) &&
												<tr>
													<td>Consumer No:</td>
													<td>{this.state.consumerNo}</td>
												</tr>
											}
											{(this.state.kNo != '' &&
												this.state.kNo != undefined &&
												this.state.kNo != null) &&
												<tr>
													<td>K_NUMBER:</td>
													<td>{this.state.kNo}</td>
												</tr>
											}
											{(this.state.consumerName != '' &&
												this.state.consumerName != undefined &&
												this.state.consumerName != null) &&
												<tr>
													<td>Consumer Name:</td>
													<td>{this.state.consumerName}</td>
												</tr>
											} */}
                                            {/* {(this.state.billDate != '' &&
												this.state.billDate != undefined &&
												this.state.billDate != null) &&
												<tr>
													<td>Bill Date:</td>
													<td>{this.state.billDate}</td>
												</tr>
											}
											{(this.state.dueDate != '' &&
												this.state.dueDate != undefined &&
												this.state.dueDate != null) &&
												<tr>
													<td>Due Date:</td>
													<td>{this.state.dueDate}</td>
												</tr>
											} */}
                                            {/* {(this.state.billNumber != '' &&
												this.state.billNumber != undefined &&
												this.state.billNumber != null) &&
												<tr>
													<td>Bill Number:</td>
													<td>{this.state.billNumber}</td>
												</tr>
											} */}

                                        </tbody>
                                    </table>

                                    {this.state.txnSubOrder != '' &&

                                        <table class="table table-bordered">
                                            <tbody>
                                                <tr>
                                                    <td colspan="3">Sub Transactions Details:</td>
                                                </tr>
                                                <tr class="table-secondary">
                                                    <td>Transactions ID</td>
                                                    <td>Amount</td>
                                                    <td>Status</td>
                                                    <td>Payment Ref.</td>
                                                </tr>

                                                {this.state.txnSubOrder.map(txRsp => (

                                                    <tr>
                                                        <td>{txRsp.id}</td>
                                                        <td>₹ {parseFloat(txRsp.txnDetails.amount).toFixed(2)}</td>
                                                        <td>{txRsp.status == 'INIT' ? 'Pending' : txRsp.status.substring(0, 1).toUpperCase() +
                                                            txRsp.status.substring(1, txRsp.status.length).toLowerCase()}</td>
                                                        <td>
                                                            {txRsp.paymentRefId}
                                                        </td>
                                                    </tr>
                                                ))
                                                }
                                            </tbody>
                                        </table>
                                    }


                                </div>
                            </div>

                            {this.state.showEmitraOriginalLogo == true &&
                                <div class="modal-footer mdftr">
                                    <button type="button" class="btn dbbtn"
                                        // data-bs-dismiss="modal" 
                                        onClick={this.closeModal}
                                    // aria-label="Close"
                                    >Clsoe</button>
                                    <button type="button" class="btn dbbtn" data-bs-dismiss="modal" onClick={this.printdiv}>Print</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                
                <FooterComponet />
            </div >

        );
    }
}


const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        billpayReduce: { biillpayOperator, billPayMobile, billpayAmount, surcharge2, transferTotalAmount2, billPayOptional,
            createOrderRes2, createOrderStatusResponse2 },
        miscReduce: { agentInfo, token, clientRole }
    },
) => ({
    errorMessage, loginErrorMessage,
    biillpayOperator, billPayMobile, billpayAmount, surcharge2, transferTotalAmount2, billPayOptional,
    createOrderRes2, createOrderStatusResponse2,
    agentInfo, token, clientRole
});

export default connect(mapStateToProps, null)(BillPayTransferDetails2);




